import { inject, injectable } from 'tsyringe';
import { ApiInjectToken, MiddlewareInjectToken } from '../../constants/tokens';
import { Apis, MiddlewareConfig, User } from '../../types';
import { BranchApi } from '../BranchApi';
import { UserApi } from '../UserApi';

@injectable()
export class AxosCryptoUserApi extends UserApi {
    constructor(
        @inject(MiddlewareInjectToken.Apis) apis: Apis,
        @inject(MiddlewareInjectToken.Config) config: MiddlewareConfig,
        @inject(ApiInjectToken.BranchApi) protected override readonly branchApi: BranchApi,
    ) {
        super(apis, config, branchApi);
    }

    async getAxosUserInfo(): Promise<User> {
        const response = await this.apis.orbis.user.userInformation();
        return response.data;
    }
}
